// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/graph.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { GraphService } from "./graph_pb";

/**
 * GetFeatureSQL returns the feature SQLs for a given deployment.
 *
 * @generated from rpc chalk.server.v1.GraphService.GetFeatureSQL
 */
export const getFeatureSQL = GraphService.method.getFeatureSQL;

/**
 * @generated from rpc chalk.server.v1.GraphService.GetFeaturesMetadata
 */
export const getFeaturesMetadata = GraphService.method.getFeaturesMetadata;

/**
 * @generated from rpc chalk.server.v1.GraphService.GetGraph
 */
export const getGraph = GraphService.method.getGraph;

/**
 * GetResolver returns a single resolver. Pass a read_mask to fetch just the
 * large sub-trees (e.g. postprocessing) that GetGraph omits from the bulk payload.
 *
 * @generated from rpc chalk.server.v1.GraphService.GetResolver
 */
export const getResolver = GraphService.method.getResolver;

/**
 * GetStreamResolver returns a single stream resolver. Pass a read_mask to fetch
 * just the large sub-trees (e.g. parse_info) that GetGraph omits from the bulk payload.
 *
 * @generated from rpc chalk.server.v1.GraphService.GetStreamResolver
 */
export const getStreamResolver = GraphService.method.getStreamResolver;

/**
 * UpdateGraph uploads the protobuf graph for a given deployment.
 *
 * @generated from rpc chalk.server.v1.GraphService.UpdateGraph
 */
export const updateGraph = GraphService.method.updateGraph;

/**
 * GetCodegenFeaturesFromGraph returns Chalk features generated from the protograph
 *
 * @generated from rpc chalk.server.v1.GraphService.GetCodegenFeaturesFromGraph
 */
export const getCodegenFeaturesFromGraph = GraphService.method.getCodegenFeaturesFromGraph;

/**
 * ApplyGraphUpdates applies a series of mutations to a deployment's graph
 *
 * @generated from rpc chalk.server.v1.GraphService.ApplyGraphUpdates
 */
export const applyGraphUpdates = GraphService.method.applyGraphUpdates;

/**
 * TestGraphMutations applies a series of mutations to a deployment's graph without persisting state
 * This allows testing graph updates before actually applying them
 *
 * @generated from rpc chalk.server.v1.GraphService.TestGraphMutations
 */
export const testGraphMutations = GraphService.method.testGraphMutations;

/**
 * GetDataLineageIndex returns a mapping of resolver names to their data lineage information
 *
 * @generated from rpc chalk.server.v1.GraphService.GetDataLineageIndex
 */
export const getDataLineageIndex = GraphService.method.getDataLineageIndex;

/**
 * GetScheduledQueryLineageIndex returns, for each scheduled query active on
 * the environment's active deployment, the resolvers and features its latest
 * query plan ran. Companion to GetDataLineageIndex: the resolver names line
 * up, so the lineage graph can hang scheduled queries off the features they
 * compute.
 *
 * @generated from rpc chalk.server.v1.GraphService.GetScheduledQueryLineageIndex
 */
export const getScheduledQueryLineageIndex = GraphService.method.getScheduledQueryLineageIndex;

/**
 * GetOfflineStoreTable returns the offline store table names for a feature
 *
 * @generated from rpc chalk.server.v1.GraphService.GetOfflineStoreTable
 */
export const getOfflineStoreTable = GraphService.method.getOfflineStoreTable;

/**
 * GetAllOfflineStoreTables returns the offline store table name for every
 * feature and internal version in the deployment. Useful for reverse-mapping
 * a feat_<hash> table name back to its feature.
 *
 * @generated from rpc chalk.server.v1.GraphService.GetAllOfflineStoreTables
 */
export const getAllOfflineStoreTables = GraphService.method.getAllOfflineStoreTables;

/**
 * DiffDeployments compares two deployment graphs and returns the diff.
 *
 * @generated from rpc chalk.server.v1.GraphService.DiffDeployments
 */
export const diffDeployments = GraphService.method.diffDeployments;

/**
 * SmartDiffDeployment automatically finds the best comparison target and diffs.
 *
 * @generated from rpc chalk.server.v1.GraphService.SmartDiffDeployment
 */
export const smartDiffDeployment = GraphService.method.smartDiffDeployment;

/**
 * DiffCandidate compares a candidate export against the latest successful
 * deployment's graph and returns the diff.
 *
 * @generated from rpc chalk.server.v1.GraphService.DiffCandidate
 */
export const diffCandidate = GraphService.method.diffCandidate;
